import { AttachmentImage } from "src/app/_models/image.model";
import { Info } from "../info/info.model";

export class Building {
  id: number;
  name: string;
  description: string;
  street: string;
  city: string;
  postCode: string;
  image?: AttachmentImage = new AttachmentImage();
  // Below optional property if building list is in form and has to be checked
  checked?: boolean;
}

export class BuildingInfo {
  id: number;
  name: string;
  description: string;
  street: string;
  city: string;
  postCode: string;
  image?: AttachmentImage = new AttachmentImage();
  // Below optional property if building list is in form and has to be checked
  checked?: boolean;
  buildingInfo: Info[];
}
